import React from "react";

import _ from "lodash";

import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { alpha } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import ObjectCard from "./ObjectCard";

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        // border: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        border: `1px solid transparent`,
        boxShadow: "none",
        padding: 0, //theme.spacing(0, 2),
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
        backgroundColor: "#FFF",
    },
    expanded: {},
    AccordionSummaryRoot: {
        // borderBottom: "none",
        borderBottom: "1px solid #ECECEC",
        marginBottom: -1,
        minHeight: "32px!important",
        "&$expanded": {
            minHeight: 32,
        },
        "&$AccordionSummaryContentExpanded": {
            // backgroundColor: "#FAFAFA",
        },
    },
    AccordionSummaryContentExpanded: {
        "& $AccordionSummaryTitle": {
            fontWeight: 400,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryTitle: {
        fontSize: "clamp(14px, 2vw, 1.25rem)",
        fontWeight: 400,
        paddingLeft: 8,
        transition: "padding-left 0.5s linear",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: 0,
        },
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2, 2, 0, 7),
        // marginLeft: 22,
        // borderLeft: "1px solid #ECECEC",
        [theme.breakpoints.down("sm")]: {
            // marginLeft: 8,
            padding: theme.spacing(2, 2, 0, 3),
        },
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.0675),
    },
    cardHeaderTitle: {
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightMedium,
    },
    objectCard: {
        position: "relative",
        borderBottom: "1px dashed #00000011",
        "&:nth-child(even)": {
            backgroundColor: "#FAFAFA",
        },
    },
    focusVisible: {
        backgroundColor: `${alpha(theme.palette.primary.main, 0.025)}!important`,
    },
}));

const ObjectsAccordion = ({ id_cechy, obiekty, expanded, onExpand, isMobile }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const handleChange = (panel) => (event, newExpanded) => {
        onExpand && onExpand(panel);
    };

    return (
        <div>
            <Accordion
                square
                expanded={expanded.includes(`obj-${id_cechy}`)}
                // expanded={true}
                onChange={handleChange(`obj-${id_cechy}`)}
                classes={{ root: classes.AccordionRoot }}
            >
                <AccordionSummary
                    aria-controls={`obj-${id_cechy}-content`}
                    id={`obj-${id_cechy}-header`}
                    expandIcon={<ExpandMoreIcon color={"primary"} fontSize={"small"} />}
                    classes={{
                        root: classes.AccordionSummaryRoot,
                        content: classes.AccordionSummaryContent,
                        expanded: classes.AccordionSummaryContentExpanded,
                        focusVisible: classes.focusVisible,
                    }}
                >
                    <Typography className={classes.AccordionSummaryTitle}>
                        {t("cecha.obiekty")}
                        <small>&nbsp;({obiekty.length})</small>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
                    <Grid container spacing={5} style={{ marginBottom: 0 }}>
                        {_.uniqBy(obiekty, "id_obiektu").map((obiekt) => {
                            return (
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    // md={obiekty?.length > 1 ? 6 : 12}
                                    md={12}
                                    key={`${id_cechy}-${obiekt.id_obiektu}`}
                                    component={"ul"}
                                    className={classes.objectCard}
                                >
                                    <ObjectCard obiekt={obiekt} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default ObjectsAccordion;
